<template>
  <q-page class="page">
    <div id="map" class="map"></div>  
  </q-page>
</template>
<script>
import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'

import {eventBus} from '../main'

export default {
  name: 'PageGeoRegions',
  components: {
    
  },
  data: function () {
    return {
      map: null,
      editableLayers: null,
      tileLayer: null,
      mapType: 'satellite',
      mapProvider: 'google',
      geoRegions: [],
      boxes:[],
      showAll: false,
      currentGpsPositionMarker: null,
      drawControl: null,
      insertControl: null,
      
      form: {
        SessionId: null,
        action: 'GeoRegions'
      },
    }
  },
  methods: {
    initMap() {
      var self = this
      this.map = new L.Map('map', {
        crs: L.CRS.EPSG3857,
        continuousWorld: true,
        worldCopyJump: false
      });

    this.map.setView([this.$store.state.session.StartLatitude, 
    this.$store.state.session.StartLongitude], this.$store.state.session.StartZoomLevel)
      


      //this.map = L.map('map').setView([this.$store.state.session.StartLatitude, 
      //  this.$store.state.session.StartLongitude], this.$store.state.session.StartZoomLevel)
      
      // by by google:
      //this.tileLayer = L.gridLayer.googleMutant({ type: this.mapType })
      //this.tileLayer.addTo(this.map)
      //document.getElementsByClassName( 'leaflet-control-attribution' )[0].style.display = 'none'
      
      //Sisstopo satellite:
      var url = 'https://wmts.geo.admin.ch/1.0.0/ch.swisstopo.swissimage/default/current/3857/{z}/{x}/{y}.jpeg'
      var opt = {
        maxZoom: 20,
        attribution: 'insafety.ch | swisstopo'
      }
      this.tileLayer = L.tileLayer.wms(url, opt)
      this.tileLayer.addTo(this.map)
      
      this.editableLayers = new L.FeatureGroup();
      this.map.addLayer(this.editableLayers);

      //Theo 8 April 2021 -----------
      //Add customer tiles
      //var lyr = L.tileLayer(this.$tilesUrl + '/{z}/{x}/{y}.png', {tms: true, opacity: 0.7, attribution: "", minZoom: 16, maxZoom: 21});
      //this.map.addLayer(lyr);
      //-----------------------------
      
      this.insertControl = new L.Control.Draw({
        position: 'topright',
        draw: {
          polyline: false,
          polygon: {
            allowIntersection: false,
            showArea: true,
            drawError: {
              color: '#b00b00',
              timeout: 1000
            },
            shapeOptions: {
              color: '#bada55'
            }
          },
          circle: false,
          marker: false,
          rectangle: false,
          circlemarker: false
        },
        edit: false
      });
      
      this.drawControl = new L.Control.Draw({
        position: 'topright',
        draw: {
          polyline: false,
          polygon: false,
          circle: false,
          marker: false,
          rectangle: false,
          circlemarker: false
        },
        edit: {
          featureGroup: self.editableLayers,
          remove: false
        }
      })

      this.map.on('draw:edited', function (e) {
        var layers = e.layers;
        var countOfEditedLayers = 0;
        layers.eachLayer(function(layer) {
          countOfEditedLayers++;
          self.editableLayers.removeLayer(layer);	
          eventBus.$emit('savePolygon', layer.IdGeoRegion)
        });
        self.map.removeControl(self.drawControl)
        console.log("Edited " + countOfEditedLayers + " layers");
      });

      this.map.on('draw:toolbarclosed', function(e){ 
        //Fires when cancel edit
        self.editableLayers.removeLayer(layer);	
        self.map.removeControl(self.drawControl)
      });

      this.map.on('draw:created', function(e){ 
        eventBus.$emit('insertPolygon', e.layer.getLatLngs())
        self.map.removeControl(self.insertControl)
      });

    },
  },
  created () {
    eventBus.$emit('loadGeoRegion', null),
    eventBus.$on('changeMapType', (data) => {
      this.map.removeLayer(this.tileLayer) 
      //this.tileLayer = L.gridLayer.googleMutant({ type: data })
      //this.tileLayer.addTo(this.map)

      if(data == "satellite"){
        //Sisstopo satellite:
      var url = 'https://wmts.geo.admin.ch/1.0.0/ch.swisstopo.swissimage/default/current/3857/{z}/{x}/{y}.jpeg'
      var opt = {
        maxZoom: 25,
        attribution: 'insafety.ch | swisstopo'
      }
      this.tileLayer = L.tileLayer.wms(url, opt)
      this.tileLayer.addTo(this.map)

      }
      if(data == "roadmap"){
        var url = 'https://wmts.geo.admin.ch/1.0.0/ch.swisstopo.pixelkarte-farbe/default/current/3857/{z}/{x}/{y}.jpeg'
        this.tileLayer = L.tileLayer.wms(url)
        this.tileLayer.addTo(this.map)
      }


    }),
    eventBus.$on('showObject', (data) => {
      data.addTo(this.map)
    }),
    eventBus.$on('showObjectCenter', (data) => {
      data.addTo(this.map)
      var xPos = data.getLatLngs()
      this.map.panTo([xPos[0][0].lat, xPos[0][0].lng])
    }),
    eventBus.$on('centerMap', (posArray) => {
      this.map.panTo(posArray)
    }),

    eventBus.$on('editObject', (data) => {
      this.map.addControl(this.drawControl)
      this.editableLayers.addLayer(data.LeafletObject);	
    }),
    eventBus.$on('removeObject', (data) => {
      data.removeFrom(this.map)
    }),
    eventBus.$on('showCurrentGpsPosition', (data) => {
      if(this.currentGpsPositionMarker != null){
        this.currentGpsPositionMarker.removeFrom(this.map)
      }
      this.currentGpsPositionMarker = L.marker(data.latlong).addTo(this.map);
      this.currentGpsPositionMarker.bindPopup("<b>" + data.label + "</b>");
    }),
    eventBus.$on('drawNewGeoRegion', (data) => {
      this.map.addControl(this.insertControl)
    }),
    eventBus.$on('saveMapSettings', (data) => {
      var zoom = this.map.getZoom()
      var center = this.map.getCenter() //lat lng
      
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "SaveMap"
      this.form.lat = center.lat
      this.form.lng = center.lng
      this.form.zoom = zoom
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
            if(response.data == "OK"){
                this.$q.notify({ message: this.$t('global.MapSettingsSaved'), type: 'positive' })
              }
              else{
                this.$q.notify('Something Wrong.')
              }   
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    }),

    eventBus.$on('changedOverlay', (value) => {
      if (value.show){
          this.$q.notify({ message: this.$t('global.AddOverlay') + ': ' + value.name, type: 'positive' })
          this.map.addLayer(value.layer);
          this.map.setView([value.latitude, value.longitude], value.zoom)
      }
      else{
        this.$q.notify({ message: this.$t('global.RemoveOverlay') + ': ' + value.name, type: 'positive' })
        this.map.removeLayer(value.layer) 
      }
    })
  },
  mounted() {
    this.initMap()   
    this.$store.dispatch('setMapLoaded')
  },
}
function round(value, decimals) {
  return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
}

</script>
<style scoped>
.map{
  padding: 20px;
  height: calc(100vh - 60px);
  width: 100%;
}
.page{
  padding: 5px;
}
</style>
